module.exports = __webpack_public_path__ + "img/11069861_L.df485494.png";